var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt2Check1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23638 5.01517C3.55355 5.01517 3 5.57151 3 6.2578V9.41707C3 14.9433 6.37552 19.9028 11.5001 21.9057C11.8216 22.0314 12.1784 22.0314 12.4999 21.9057C17.6245 19.9028 21 14.9433 21 9.41707V6.2578C21 5.57151 20.4465 5.01517 19.7636 5.01517H19.1838C18.1518 5.01517 17.2085 4.4292 16.747 3.50156L16.5528 3.11116C16.214 2.43017 15.5215 2 14.7639 2H9.23607C8.47852 2 7.786 2.43017 7.44721 3.11116L7.253 3.50156C6.79151 4.4292 5.84816 5.01517 4.81625 5.01517H4.23638ZM17.5303 9.56841L11.5303 15.5987C11.2374 15.8931 10.7626 15.8931 10.4697 15.5987L7.46967 12.5836C7.17678 12.2892 7.17678 11.8119 7.46967 11.5176C7.76256 11.2232 8.23744 11.2232 8.53033 11.5176L11 13.9997L16.4697 8.50238C16.7626 8.20801 17.2374 8.20801 17.5303 8.50238C17.8232 8.79676 17.8232 9.27403 17.5303 9.56841Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt2Check1);
export default __webpack_public_path__ + "static/media/shield-alt-2-check-1.63253fc94d5a8af7a7c197ac6921a450.svg";
export { ForwardRef as ReactComponent };